import {gql} from "@apollo/client";

export const removeTemplateMutation = gql`
    mutation removeJobTemplate($id: Int!) {
        removeJobTemplate(id: $id)
    }
`;

export default removeTemplateMutation;